<template>
    <div class="dashboard-layout">
      <template v-if="!getUserRoleIsNewUser">
        <template class="mt-10">
          <dashboard-info-blocks/>
        </template>
        <template class="mt-10">
          <div class="row">
            <div class="col-md-6 col-12 pb-sm-5">
              <user-daily-status class="mt-20"/>
            </div>
            <div class="col-md-6 col-12 pb-5">
              <user-monthly-reports class="mt-20"/>
              <dashboard-articles class="mt-20"/>
              <user-upcoming-vacation class="mt-20"/>
            </div>
          </div>
        </template>
      </template>
      <template v-else>
        <new-user-card></new-user-card>
      </template>
    </div>
</template>

<script>

import Pagination from "../small_components/Pagination";
import SiteStatusStatistic from "../parts/Dashboard/Administrator/SiteStatusStatistic.vue";
import UserDailyStatus from "../parts/Dashboard/User/UserDailyStatus.vue";
import DashboardArticles from '../parts/Dashboard/User/DashboardArticles.vue'
import SmallTitle from "../small_components/SmallTitle.vue";
import {ROUTES_NAMES as routes_names} from "../../router";
import {mapGetters} from "vuex";
import NewUserCard from "../parts/Dashboard/User/NewUserCard.vue";
import UserUpcomingVacation from "../parts/Dashboard/User/UserUpcomingVacation.vue";
import InfoBlock from "../small_components/InfoBlock.vue";
import DashboardBlock from "../small_components/DashboardBlock.vue";
import DashboardInfoBlocks from "../parts/Dashboard/User/DashboardInfoBlocks.vue";
import UserMonthlyReports from "../parts/Dashboard/User/UserMonthlyReports.vue";
export default {
    name: 'DashboardLayout',
    components: {
      UserMonthlyReports,
      DashboardInfoBlocks,
      DashboardBlock,
      InfoBlock,
      NewUserCard,
      SiteStatusStatistic,
      SmallTitle,
      DashboardArticles,
      UserDailyStatus,
      Pagination,
      UserUpcomingVacation
    },
  computed: {
    routes_names() {
      return routes_names
    },
    ...mapGetters([
      'getUserRoleIsAdmin',
      'getUserRoleIsNewUser'
    ]),
  }
}
</script>
